import React, { useState } from 'react'
import { firestore } from '../../../../firebase';

function EditSingleLeague({league}) {

    const [show, setShow] = useState(false)

    const [leagueOrder, setLeagueOrder] = useState(league?.order)
    const [leagueLogo, setLeagueLogo] = useState(league?.league_logo)
    const [leagueName, setLeagueName] = useState(league?.league_name)
    const [leagueId, setLeagueId] = useState(league?.league_id)

    const [error, setError] = useState("");
    const [message, setMessage] = useState("")

    async function editLeague(e, id) {
        e.preventDefault();
        try {
            const leaguesRef = firestore.collection("top-leagues").doc(id);
            const data = {
                order: +leagueOrder,
                league_id: leagueId,
                league_logo: leagueLogo,
                league_name: leagueName
            }
            leaguesRef.update(data)
            setMessage("Oppdatert")
        } catch (error) {
            setError(error)
        }
    }

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <div className="card ">
            <div className="card-header" onClick={toggle} style={{cursor: "pointer"}}>
                <img src={league.league_logo} alt={league.league_name} className="teamLogo mr-2" />
                {league.league_name} Order: {league.order}
                <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span>
            </div>
            {show && (
                <div className="card-body">
                    <form className="mt-3" onSubmit={(e) => editLeague(e, league.id)}>
                        <label>League name</label>
                        <input className="form-control mb-2" value={leagueName} onChange={e => setLeagueName(e.target.value)} />

                        <label>Logo <span><img src={leagueLogo} alt={league.league_name} className="teamLogo mr-2" /></span></label>
                        <input className="form-control mb-2" value={leagueLogo} onChange={e => setLeagueLogo(e.target.value)} />

                        <label>League Id</label>
                        <input value={leagueId} onChange={e => setLeagueId(e.target.value)} type="number" className="form-control mb-2" />
                        <label>Order</label>

                        <input value={leagueOrder} onChange={e => setLeagueOrder(e.target.value)} type="number" className="form-control mb-2" />
                        {message && <div className="alert alert-success">{message}</div>}
                        {error && <div className="alert alert-danger">{error}</div>}
                        <button className="btn btn-success">Oppdater</button>
                    </form>
                </div>
            )}

        </div>
    )
}
export default EditSingleLeague